export default async function fetchCheckRoom(token: string, roomId: string) {
  try {
    const res = await fetch("/api/check-room", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ roomId })
    });
    const data = (await res.json()) as { ok: boolean };
    return {
      data,
      error: null
    };
  } catch (err) {
    console.error(err);
    return { data: null, error: err };
  }
}
